<div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">

    <div style="font-weight: bold;"> {{ name }}</div>
    <div style="margin-bottom: 10px;">Total: {{ count }}</div>
    
    <button mat-raised-button color="primary" (click)="onOpenTickets()">Open Overview</button>
</div>